module.exports = __webpack_public_path__ + "2975223c3b784378ceeb015fa772637e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/plus_increment_enabled.svg
// module id = 6dLN
// module chunks = 5